import { useFetchPriceRoundingRuleById } from '@retail/rounding/data-access';
import { useUserBrands } from '@retail/app/stores/selected-context';
import { PriceRoundingRuleConfig } from '@retail/rounding/types';
import ViewRoundingRuleDialog from './ViewRoundingRuleDialog';
import { brandLogo } from '@retail/utils';
import { withDialogSuspenseErrorBoundary } from '@retail/components';
import { PriceRoundingRuleMemberHeader } from '@retail/rounding/components';

interface Props {
  open: boolean;
  onClose: () => void;
  priceRoundingRuleId: number;
}

const LookupRoundingRuleDialog = ({ open, onClose, priceRoundingRuleId }: Props) => {
  const { selectedBrand } = useUserBrands();

  const { data: priceRoundingRuleDto } = useFetchPriceRoundingRuleById({
    ruleSetId: priceRoundingRuleId,
    suspense: true,
  });

  const priceRoundingRule = PriceRoundingRuleConfig.fromDto(priceRoundingRuleDto!, {
    name: selectedBrand.name,
    id: selectedBrand.brandId,
    imgUrl: brandLogo(selectedBrand.brandId).logo,
  });

  return (
    <ViewRoundingRuleDialog
      open={open}
      onClose={onClose}
      priceRoundingRuleConfig={priceRoundingRule}
      renderHeader={() => <PriceRoundingRuleMemberHeader ruleSetConfig={priceRoundingRule} />}
    />
  );
};

export default withDialogSuspenseErrorBoundary(LookupRoundingRuleDialog);
